import { formatDate } from '@domains/orchestrator-pricing-committee/utils/dates';

export const StepInfoTracker = ({
  status,
  date,
  colorStatus,
}: {
  status: string;
  date: string;
  colorStatus: string;
}) => {
  const dateStr = formatDate(date);
  return (
    <div>
      <div style={{ fontWeight: 'bold', color: colorStatus }}>{status}</div>
      <div style={{ fontSize: '0.9rem' }} className="text-muted">
        {dateStr}
      </div>
    </div>
  );
};
